export default __webpack_public_path__ + "static/media/about6.38b00e90.jpeg";